import INDIGO from "../assets/Images/INDIGO.png";
import AIRASIA from "../assets/Images/AIRASIA.png";
import AIRINDIA from "../assets/Images/AIRINDIA.png";
import AIRINIDAEXPRESS from "../assets/Images/AIRINIDAEXPRESS.png";
import VISTARA from "../assets/Images/VISTARA.png";
import SPICEJET from "../assets/Images/SPICEJET.png";
import AKASHAAIR from "../assets/Images/AKASA AIR.png";
import ALPINEAIR from "../assets/Images/ALPINEAIR.png";
import AIX from "../assets/Images/AIX.png";

export const flightImages = [
  { name: "IndiGo", image: INDIGO },
  { name: "AirAsia India", image: AIRASIA },
  { name: "SpiceJet", image: SPICEJET },
  { name: "AI Express", image: AIRINIDAEXPRESS },
  { name: "Air India", image: AIRINDIA },
  { name: "Vistara", image: VISTARA },
  { name: "Air India Express", image: AIX },
  { name: "Akasa Air", image: AKASHAAIR },
  { name: "Alpine Air Express ", image: ALPINEAIR },
];

export const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

export const STATUSARRAY = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const PAYMENT_STATUS_ARRAY = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Pending", value: "Pending" },
];

export const CANCELLATIONTYPES = [
  {
    label: "Normal Cancel",
    value: 1,
    Options: [
      {
        CancelCode: "015",
        Description: "Please cancel my ticket with Applicable Penalty",
      },
      {
        CancelCode: "005",
        Description: "I cancelled the ticket directly with Airline",
      },
      {
        CancelCode: "001",
        Description: "Other",
      },
    ],
  },
  {
    label: "Full Refund",
    value: 2,
    Options: [
      {
        CancelCode: "016",
        Description: "Flight Schedule Changed by Airline",
      },
      {
        CancelCode: "005",
        Description: "I cancelled the ticket directly with Airline",
      },
      {
        CancelCode: "004",
        Description:
          "Received a communication from Airline that Flight is not Operational",
      },
      {
        CancelCode: "008",
        Description: "Flight Cancelled by the Airline",
      },
      {
        CancelCode: "001",
        Description: "Other",
      },
    ],
  },
  {
    label: "No Show",
    value: 3,
    Options: [
      {
        CancelCode: "011",
        Description: "Claim No Show Tax Refund",
      },
      {
        CancelCode: "001",
        Description: "Other",
      },
    ],
  },
];

export const MONTHARRAY = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const YEARARRAY = [
  { label: "2025", value: 2025 },
  { label: "2026", value: 2026 },
  { label: "2027", value: 2027 },
  { label: "2028", value: 2028 },
  { label: "2029", value: 2029 },
  { label: "2030", value: 2030 },
  { label: "2031", value: 2031 },
  { label: "2032", value: 2032 },
  { label: "2033", value: 2033 },
  { label: "2034", value: 2034 },
];

export const TOUR_TYPE = [
  { label: "International", value: 1 },
  { label: "Domestic", value: 2 },
];
export const TRAVEL_TYPE = [
  { label: "International", value: "INTERNATIONAL" },
  { label: "Domestic", value: "DOMESTIC" },
];

export const POPULARARRAY = [
  { label: "Popular", value: 1 },
  { label: "Not Popular", value: 2 },
];

export const GSTPERARRAY = [
  { label: "GST 5%", value: 5 },
  { label: "GST 18%", value: 18 },
];

export type ISelectionType = {
  value: number;
  label: string;
};

export const INSERT_OPT_TYPE = 1;
export const EDIT_OPT_TYPE = 2;
export const DELETE_OPT_TYPE = 3;
export const GET_BY_GUID_OPT_TYPE = 4;
export const GET_ALL_ACTIVE_WITH_FILTER_OPT_TYPE = 5;
export const GET_ALL_OPT_TYPE = 6;
export const ACTIVE_INACTIVE_OPT_TYPE = 7;

export const DRAWER_WIDTH = 400;

export const MAIN_GST_PER = 18;

// export const INSERT_ACCESS = "1";
// export const EDIT_ACCESS = "2";
// export const DELETE_ACCESS = "3";
// export const PDF_DOWNLOAD_ACCESS = "4";
// export const EXCEL_EXPORT_ACCESS = "5";

export const INSERT_ACCESS = "1";
export const EDIT_ACCESS = "2";
export const DELETE_ACCESS = "3";
export const PDF_DOWNLOAD_ACCESS = "4";
export const EXCEL_EXPORT_ACCESS = "5";
export const PRINT_ACCESS = "6";
export const WHATSAPP_SEND_ACCESS = "7";
export const EMAIL_SEND_ACCESS = "8";

export const INITIALS = ["MR", "MRS", "MSTR", "MS", "MISS"];
export const TRAVELLER_GENDER = [
  { label: "Male", value: 1 },
  { label: "Female", value: 2 },
];

export const PAYMENT_METHOD = [
  { value: 1, label: "netbanking" },
  { value: 2, label: "upi" },
  { value: 3, label: "card" },
  { value: 4, label: "wallet" },
  { value: 5, label: "emi" },
];

export const REFUND_STATUS = [
  { value: 1, label: "partial" },
  { value: 1, label: "full" },
];

export const SECTOR_TYPE_FOR_COUPEN = [
  { label: "International Flights", value: "INTERNATIONAL FLIGHTS" },
  { label: "Domestic Flights", value: "DOMESTIC FLIGHTS" },
  { label: "All Flights", value: "ALL FLIGHTS" },
  { label: "Hotels", value: "HOTELS" },
  { label: "Bookings", value: "BOOKINGS" },
];

export const SECTOR_TYPE = [
  { label: "INTERNATIONAL", value: "INTERNATIONAL" },
  { label: "DOMESTIC", value: "DOMESTIC" },
];

export const BALANCE_TYPE = [
  { label: "Refundable", value: "Refundable" },
  { label: "Non Refundable", value: "Non Refundable" },
];

export const DEPOSITED_MODE = [
  { label: "ATM", value: "ATM" },
  { label: "Counter", value: "Counter" },
  { label: "Dropped in Box", value: "Dropped in Box" },
];

export const ENTRY_TYPE = [
  { label: "Return", value: "Return" },
  { label: "Add", value: "Add" },
];

export const DISC_TYPE = [
  { label: "Percentage", value: "PER" },
  { label: "Rupees", value: "RS" },
];

export const BOOKING_SEARCH_TYPE = [
  { label: "Confirm Booking", value: "Confirmed" },
  { label: "Pending Booking", value: "Onprogress" },
  { label: "Cancelled Booking", value: "Cancelled" },
  { label: "Failed Booking", value: "Failed" },
];

export const PROMO_TYPE = [
  { label: "Auto", value: "Auto" },
  { label: "Manual", value: "Manual" },
];

export const TOPUP_REQUEST_TYPE = [
  { label: "Cheque", value: "Cheque" },
  { label: "Net Transfer", value: "Net Transfer" },
  { label: "Cash", value: "Cash" },
  { label: "Other", value: "Other" },
];

export const SEARCH_TYPE = [
  { label: "Ref No", value: "RefNo" },
  { label: "Airline PNR", value: "AirlinePNR" },
  { label: "Mobile No", value: "MobileNo" },
];

export const BOOLEAN = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
];

export const SEASONTYPE = [
  { label: "Winter", value: "Winter" },
  { label: "Summer", value: "Summer" },
  { label: "Monsoon", value: "Monsoon" },
];

export const TRAVELTYPE = [
  { label: "TOUR", value: "TOUR" },
  { label: "PACKAGE", value: "PACKAGE" },
];

export const SECTORTYPE = [
  { label: "DOMESTIC", value: "DOMESTIC" },
  { label: "INTERNATIONAL", value: "INTERNATIONAL" },
];

export const RATETYPE = [
  { label: "PER PERSON", value: "PER PERSON" },
  { label: "PER COUPLE", value: "PER COUPLE" },
];

export const LOGS_FORMS = [
  { value: "User", label: "User" },
  { value: "Gift Code", label: "Gift Code" },
  { value: "Cancel Booking", label: "Cancel Booking" },
  { value: "Membership Plan", label: "Membership Plan" },
  { value: "Wallet Return", label: "Wallet Return" },
  { value: "Withdrawal Request", label: "Withdrawal Request" },
];
